"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createAnimationElement = void 0;

var createAnimationElement = function createAnimationElement(element) {
  var animationElement = element.cloneNode(true);
  animationElement.style.position = 'fixed';
  animationElement.style.transformOrigin = 'left top';
  animationElement.style.transition = 'none';
  animationElement.style.marginLeft = 0;
  animationElement.style.marginTop = 0;
  animationElement.style.marginRight = 0;
  animationElement.style.marginBottom = 0;
  animationElement.style.backfaceVisibility = 'hidden';
  document.body.appendChild(animationElement);
  return animationElement;
};

exports.createAnimationElement = createAnimationElement;
var _default = createAnimationElement;
exports["default"] = _default;